import type { QuizSteps } from "@/types/api.types";
import Graph from "@/components/atoms/Graph";

import parse from "html-react-parser";
import OfferCoupon from "@/components/molecules/OfferCoupon";
import OfferTestimonials from "../molecules/OfferTestimonials";
import OfferBodyComparison from "../molecules/OfferBodyComparison";
import { getWeightKg, calculateMonths, formatWeight } from "@/utils/quizUtils";

const OfferPage = ({ step, answers = {} }: QuizSteps) => {
  const currentWeight = formatWeight(answers["weight_current"]);
  const goalWeight = formatWeight(answers["weight_goal"]);

  const currentKg = getWeightKg(answers["weight_current"]);
  const goalKg = getWeightKg(answers["weight_goal"]);

  const diffKg =
    currentKg != null && goalKg != null ? Math.abs(currentKg - goalKg) : null;
  const months = diffKg != null ? calculateMonths(diffKg) : null;
  const resolvedTitle = (step?.title ?? "")
    .replace("###goal_weight###", goalWeight)
    .replace("###calculated_month###", months != null ? `${months}` : "—");

  return (
    <div className="mx-auto gap-9 md:gap-14 flex-col flex items-center max-w-[1100px]">
      <div className="w-screen relative -ml-[50vw] -mr-[50vw] flex justify-center">
        <div className="max-w-[1100px] w-full px-2.5">
          <span className="text-[24px] md:text-[36px] text-center block">
            {parse(resolvedTitle)}
          </span>
        </div>
      </div>

      <div className="mx-auto max-w-[620px] w-full gap-9 md:gap-14 flex flex-col items-center">
        <div className="w-full max-w-[600px]">
          <Graph
            currentWeight={currentWeight}
            goalWeight={goalWeight}
            showRedLine={false}
            gradientStart="#BDE2FF"
            gradientEnd="#DEF2FF"
          />
        </div>

        <OfferBodyComparison step={step} answers={answers} />
        <OfferCoupon step={step} />
        <OfferTestimonials step={step} />
      </div>
    </div>
  );
};

export default OfferPage;
